import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Chart } from 'chart.js';
import { Location } from '@angular/common';
import { LogisticsService } from 'src/app/Services/Logistics/logistics.service'
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { DatePipe } from '@angular/common'
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { colors } from 'src/utils/colors';
import {  ChangeDetectionStrategy } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import * as moment from 'moment';
import  parse  from 'date-fns/parse'
import {

  CalendarMonthViewBeforeRenderEvent,
  CalendarWeekViewBeforeRenderEvent,
  CalendarDayViewBeforeRenderEvent,

} from 'angular-calendar';

import {
  isSameMonth,
  isSameDay,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  format,
} from 'date-fns';

interface Schedules {
  fullName: string;
  pickupTime: string;
  checkOut: string;
  pid:string;
  phoneNumber:string;
  branch:string;
  salesRep:string;
  salesRepID:string;
   
 }


@Component({
  selector: 'app-logistics-main',
  templateUrl: './logistics-main.component.html',
  styleUrls: ['./logistics-main.component.css']
})
export class LogisticsMainComponent implements OnInit {

  searchForm: FormGroup;
  searchText;
  

  date;
  events: any;
  items: Array<CalendarEvent<{ time: any }>> = [];
  viewDate: Date = new Date();
  view: CalendarView = CalendarView.Month;
  events$: Observable<CalendarEvent<{ schedules: Schedules }>[]>;
  activeDayIsOpen: boolean = false;

 //_url= 'http://multiinspectionreport.com/reception/api';
// _url= 'https://test.appointele.com/api';
 //_url= 'https://demo.appointele.com/api';
_url= 'https://ciot.appointele.com/api';
//_url= 'https://ciot.appointele.ca/api';
 

  todaypersonCount;
  alltodaysschedules=[];
  error=[];
  currentUser:User;
  username;
  branch;
role;
success;
color;

loggedInUsername
loggedInUserBranch;
loggedInUserFullname;
loggedInUserId;

  constructor(private fb: FormBuilder,
      private router: Router,
      private _location: Location,
      private actroute: ActivatedRoute,
      private _authenticationService: AuthenticationService,
      private _logistics: LogisticsService,
      private _http: HttpClient,
      public datepipe: DatePipe) {

        let now = moment();

        this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
        if(this.currentUser){
          this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
          this.branch=this.currentUser.branch;
          this.role=this.currentUser.role;


          this.loggedInUsername=this.currentUser.userName;
          this.loggedInUserFullname= this.username;
          this.loggedInUserBranch= this.branch
          this.loggedInUserId=this.currentUser.userName;
      
          
      
         }
}

  ngOnInit(): void {
    this.getTodaysSchedules();
    this.fetchEvents();
  }



  getTodaysSchedules(){
    console.log(this.branch);
  
    this._logistics.getAllSchedulesForBranch(this.branch).subscribe(
      (res) => {
        this.alltodaysschedules= res;
        console.log(this.alltodaysschedules);
        
      },
      (err) => {
        this.error = err;
      }
    );
  
  }


  
  
 deleteSchedule(list){
  this._logistics.deleteSchedulebypid(list)
  .subscribe(//subscribe to Observable
    response => {console.log('Success!', response);
    this.success=response['SUCCESS'];
        
    document.getElementById("openSuccessDeleteModalButton").click();
  },
    error => {console.error('Error!', error);
    this.error=error.error.text ;
  }       
  );
}


 patchCheckIn(){
  let dateTime = new Date();
  this.date=new Date();
let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');


}




getTodaysSchedule(){
  console.log(this.branch);

  this._logistics.getAllTodaysSchedules(this.branch).subscribe(
    (res) => {
      this.alltodaysschedules= res[0];
     // console.log(this.alltodaysappointment);
      
    },
    (err) => {
      this.error = err;
    }
  );

}



patchCheckOut(){
  let dateTime = new Date();
  this.date=new Date();
let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');

  
}



openSchedule(list){
  console.log(list.pid);
  ;
  if(list.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:list.appointmentID,extra1:list.timeIn,extra2:list.salesRep,extra3:list.branch,extra4:list.pickupTime}],{relativeTo:this.actroute});
  }else{
 
  this.router.navigate(['../schedule-details', { extra: list.pid, extra1: list.fullName,extra2:list.phoneNumber,extra3:list.branch,extra4:list.pickupTime }], { relativeTo: this.actroute });
  }
}


  editSchedule(list){
    console.log(list);
     if(list.fullName=='Lunch'){
       this.router.navigate(['../lunch-assignment',{extra:list.pid,extra1:list.timeIn,extra2:list.salesRep,extra3:list.branch,extra4:list.pickupTime}],{relativeTo:this.actroute});
     }else{
    
    
      this.router.navigate(['../schedule-edit',{extra:list.pid,extra1:list.fullName,extra2:list.phoneNumber,extra3:list.branch,extra4:list.pickupTime}],{relativeTo:this.actroute});
     }
   }

   
   
  backClicked() {
    this._location.back();
  }



  scrollToTableView(){
    var myElement = document.getElementById('todayTableview');
  var topPos = myElement.offsetTop;
  window.scrollTo({left: 0, top:  830});
  //myElement.scrollIntoView();
   /**  let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
          window.scrollTo({left: 0, top: pos - 2000}); // how far to scroll on each step
          
      } else {
          window.clearInterval(scrollToTop);
      }
  }, 16);*/
  }


  
  /************************************************************************************************************************** */
  //Calendar
  /**************************************************************************************************************************** */
  fetchEvents(): void {

    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay,
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay,
    }[this.view];

  this.events$ = this._http.get(`${this._url}/active_all_logistics_schedules_for_branch_get.php?branch=${this.branch}`)
  .pipe(
    map(({ results }: { results: Schedules[] }) => {
      console.log(results);
      return results.map((schedules: Schedules) => {
        //this.colorForRep(schedules.salesRep);
     /**   if(appointment.salesRep=='Nicolas Salazar'){
          this.color=colors.blue;
        }else if(appointment.salesRep=='Tom Kizito'){
          this.color=colors.yellow;
        }**/
       
        this.colorForRep(schedules.salesRep);
        
        return {
        
          title: schedules.fullName+' - '+(new Date(schedules.pickupTime).toLocaleTimeString()).replace(/:\d+ /, ' ')+' - '+schedules.salesRep,
          start: new Date(
            schedules.pickupTime
          ),
          end: new Date(schedules.checkOut),
          color:this.color,
         // cssClass: main-dashboard.component.css,
          meta: {
            schedules,
          },

        };
      });
    })
  );


}


dayClicked({
  date,
  events,
}: {
  date: Date;
  events: CalendarEvent<{ schedules: Schedules}>[];
}): void {
  if (isSameMonth(date, this.viewDate)) {
    if (
      (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
      events.length === 0
    ) {
      this.activeDayIsOpen = false;
    } else {
      this.activeDayIsOpen = true;
      this.viewDate = date;
    }
  }

}



eventClicked(event: CalendarEvent<{ schedules: Schedules }>): void {
  /**window.open(
    `https://multiinspectionreport.com/reception/appointment-details;extra=${event.meta.appointment.appointmentID};extra1=${event.meta.appointment.fullName};extra2=${event.meta.appointment.phoneNumber}`,
    '_blank'
  );**/

  console.log(event.meta.schedules);
  if(event.meta.schedules.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:event.meta.schedules.pid,extra1:event.meta.schedules.pickupTime,extra2:event.meta.schedules.salesRepID,extra3:event.meta.schedules.branch,extra4:event.meta.schedules.pickupTime}],{relativeTo:this.actroute});
  }else{
 
  this.router.navigate(['../schedule-details', { extra:event.meta.schedules.pid, extra1: event.meta.schedules.fullName,extra2:event.meta.schedules.phoneNumber,extra3:event.meta.schedules.branch,extra4:event.meta.schedules.pickupTime}], { relativeTo: this.actroute });
}
}





isAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.Administrator;
}

isSystemAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
}

isReceptionist() {
  return this.currentUser && this.currentUser.role === UserRole.Receptionist;
}

isSalesRep() {
  return this.currentUser && this.currentUser.role === UserRole.SalesRepresentative;
}

isPowerUser() {
  return this.currentUser && this.currentUser.role === UserRole.PowerUser;
}

isSalesSupport() {
  return this.currentUser && this.currentUser.role === UserRole.SalesSupport;
}

is1020Lawrence() {
  return this.currentUser && this.currentUser.branch === "1020 Lawrence";
}




colorForRep(salesRep){
  if(salesRep=='Nicolas Salazar'){
    this.color=colors.darkgray;
  }else if(salesRep=='Sonia Garofolo'){
    this.color=colors.yellow;
  } else if(salesRep=='Nancy Ventura'){
    this.color=colors.purple;
  }else if(salesRep=='Olivia Dobrovich'){
    this.color=colors.pink;
  } else if(salesRep=='Jason Branco'){
    this.color=colors.green;
  }else if(salesRep=='Ryan Li'){
    this.color=colors.darkgreen;
  } else if(salesRep=='Caelyn Huang'){
    this.color=colors.purpleblue;
  }else if(salesRep=='Alyssa Vani'){
    this.color=colors.info;
  } else if(salesRep=='Alex Karlee Lafarciola'){
    this.color=colors.brightblue;
  }else if(salesRep=='Magdalena Wojtachnio'){
    this.color=colors.orange;
  } else if(salesRep=='Christelle Aniceto'){
    this.color=colors.lightgray;
  }else if(salesRep=='Zach Cannarozzo'){
    this.color=colors.blue;
  } else if(salesRep=='Alexia Rupolo'){
    this.color=colors.brown;
  }else if(salesRep=='Sandra Arango'){
    this.color=colors.grayblue;
  } else if(salesRep=='Lauren Richardson'){
    this.color=colors.coralred;
  }
  
   //1020 Lawrence
   else if(salesRep=='Zohaib Salman'){
    this.color=colors.blue;
  } else if(salesRep=='Melissa Hu'){
    this.color=colors.purple;
  } else if(salesRep=='Manal Aziz'){
    this.color=colors.darkgreen;
  } else if(salesRep=='Gianna Cammalleri'){
    this.color=colors.orange;
  } else if(salesRep=='Danny Cui'){
    this.color=colors.lightgray;
  } else if(salesRep=='Jacquie Kraizer'){
    this.color=colors.pink;
  }
  
  //3050 Vega
  
  else if(salesRep=='Caron Galea'){
    this.color=colors.blue;
  } else if(salesRep=='Erin Ages'){
    this.color=colors.purple;
  } else if(salesRep=='Paola Salafia'){
    this.color=colors.darkgreen;
  } else if(salesRep=='Samantha Garofalo'){
    this.color=colors.orange;
  } else if(salesRep=='Peter Petrauskas'){
    this.color=colors.lightgray;
  } else if(salesRep=='Kristine Golfi'){
    this.color=colors.pink;
  }
  
  else if(salesRep==''){
    this.color=colors.red;
  }else {
    this.color=colors.black;
  }

}
}
